<template>
  <div style="position:relative">
    <div class="md-small-hide product-table">
      <!-- Desktop view -->
      <md-table v-for="itemMaster in products" v-bind:key="itemMaster.id" style="margin-top:10px;">
        <!--v-if="type=='estore'", table header cell  -->
        <md-table-row v-if="type=='estore' && (itemMaster.childOfMaster === null || itemMaster.childOfMaster === 0)">
          <md-table-head class="tb-product-col">{{$t('select-your-products')}}</md-table-head>
          <md-table-head>{{$t('serial-number')}}</md-table-head>
          <md-table-head v-if="!(store == 'jp')">{{$t('returns-eligibility')}}</md-table-head>
          <md-table-head style="width:150px;">{{$t('warranty')}}</md-table-head>
        </md-table-row>

        <!--v-if="type=='retail'", table header cell  -->
        <md-table-row v-if="type=='retail' && (itemMaster.childOfMaster === null || itemMaster.childOfMaster === 0)">
          <md-table-head class="tb-product-col">{{$t('select-your-products')}}</md-table-head>
          <md-table-head>{{$t('serial-number')}}</md-table-head>
          <md-table-head v-if="type=='retail'">{{$t('order-id')}}</md-table-head>
          <md-table-head>{{$t('proof-purchase')}}</md-table-head>
          <md-table-head style="width:150px;">{{$t('purchase-date')}}</md-table-head>
        </md-table-row>

        <!-- table row (master) => Show Master Product, v-if="itemMaster.childOfMaster == 0 -->
        <md-table-row v-if="itemMaster.childOfMaster === null || itemMaster.childOfMaster === 0">
          <!-- prod image + checkbox -->
          <md-table-cell>
            <div class="md-layout md-alignment-center-center" v-on:click="select(itemMaster)" :class="itemMaster.submitted?'':'pointer'">
              <span class="tb-product-exists" v-if="itemMaster.submitted">{{$t('rma-exists')}}</span>
               <!-- <span class="tb-product-exists" style="background-color:blue" v-if="itemMaster.childOfMaster != 0 || itemMaster.childOfMaster != null">{{(itemMaster.childOfMaster == 0) ? "Master" : "Child" }} </span>  -->

              <div class="md-layout-item md-size-10">
                <md-checkbox v-model="itemMaster.selected" :disabled="itemMaster.submitted || (store == 'jp' && itemMaster.warrantyDaysRemain <= 0)" class="product-checkbox" v-on:change="select(itemMaster, 'change')" v-on:click.stop=""></md-checkbox>
              </div>
              <div class="md-layout md-size-40" style="align-items:center">
                <div class="row-prod-item" style="width:100%; height:80px;background-size:contain;background-repeat:no-repeat" v-bind:style="{ backgroundImage: 'url(' + itemMaster.image + ')' }">
                  <img class="tb-product-image" :src="itemMaster.image" srcset="https://img.creative.com/images/dot-clear.gif" />
                </div>
              </div>
              <div class="md-layout">
                <div class="tb-product-desc">
                  <h4>{{itemMaster.name}}</h4>
                  <div class="md-layout-item md-size-100 serial-help-link" style="padding-top:0" v-if="type=='retail'"><a v-on:click.stop="removeProduct(itemMaster)">{{$t('remove')}}</a></div>
                </div>
              </div>
            </div>
          </md-table-cell>

          <!-- serialNumber -->
          <md-table-cell>
            <div class="md-layout" v-if="!itemMaster.serialNumberFinish && !itemMaster.serialNumberLocked && !itemMaster.submitted">
              <div class="md-layout-itemMaster md-size-100">
                <input type="text" :class="'serial-num-input'+(type=='estore'?' serial-num-input-estore':'')" v-model="itemMaster.serialNumber" v:value="itemMaster.serialNumber" :placeholder="$t('enter-serial')" maxlength="19" v-on:click.stop="" v-on:keyup.enter="serialNumSubmit(itemMaster)" v-on:blur="serialNumSubmit(itemMaster)" />
              </div>
              <br />
              <div class="md-error" v-if="itemMaster.serialNumInvalid || itemMaster.serialNumNotMatch" style="padding-top:8px;">{{$t('enter-serial-number')}} <span v-if="false">- {{itemMaster.extraMsg}}</span></div>
              <div class="md-error" v-if="itemMaster.serialNumCreated" style="padding-top:8px;">{{$t('serial-num-submitted')}} <span v-if="false">- {{itemMaster.extraMsg}}</span></div>
              <div class="md-layout-itemMaster md-size-100 serial-help-link"><a v-on:click.stop="serialNumHelp">{{$t('how-find-serial-num')}}</a></div>
            </div>
            <div class="md-layout" v-if="itemMaster.serialNumberFinish || itemMaster.serialNumberLocked">
              <div class="md-layout-itemMaster md-size-100">
                {{itemMaster.serialNumber}}
              </div>
              <div class="md-layout-itemMaster md-size-100 serial-help-link" v-if="!itemMaster.serialNumberLocked && !itemMaster.submitted"><a v-on:click.stop="itemMaster.serialNumberFinish=false">{{$t('edit')}}</a></div>
            </div>
          </md-table-cell>

          <!--v-if="type=='retail'"-->
          <md-table-cell v-if="type=='retail'">
            <div class="md-layout" v-if="!itemMaster.invoiceNumberFinish && !itemMaster.submitted">
              <div class="md-layout-itemMaster md-size-100">
                <input type="text" class="invoice-num-input" v-model="itemMaster.invoiceNumber" maxlength="20" :placeholder="$t('order-number')" v-on:click.stop="" v-on:keyup.enter="invoiceSubmit(itemMaster)" v-on:blur="invoiceSubmit(itemMaster)" />
              </div>
              <div class="md-layout-itemMaster md-size-100 serial-help-link">
                <span>{{$t('for-amazon-order')}}</span>
              </div>
            </div>
            <div class="md-layout" v-if="itemMaster.invoiceNumberFinish">
              <div class="md-layout-itemMaster md-size-100">
                {{itemMaster.invoiceNumber}}
              </div>
              <div class="md-layout-itemMaster md-size-100 serial-help-link" v-if="!itemMaster.submitted"><a v-on:click.stop="itemMaster.invoiceNumberFinish=false">{{$t('edit')}}</a></div>
            </div>
          </md-table-cell>

          <!-- return eligibity, yes | no -->
          <md-table-cell v-if="type=='estore' &&  store != 'jp'">
            <span v-if="itemMaster.returnsEligibility">{{$t('yes')}}</span>
            <span v-if="!itemMaster.returnsEligibility">{{$t('no')}}</span>
          </md-table-cell>

          <!-- v-if=="type=='retail'" (POP Upload) -->
          <md-table-cell v-if="type=='retail'">
            <div style="position:relative; overflow:hidden;" v-on:click.stop="" v-if="!itemMaster.purchaseProof || itemMaster.purchaseProof.length == 0">
              <input type="file" v-on:change="upload($event, itemMaster)" style="position:absolute; z-index: 10; top:0; left: 0; font-size:100px;opacity:0;" />
              <md-button class="md-accent md-raised upload-button">{{$t('choose-file')}}</md-button>
            </div>
            <div v-if="itemMaster.purchaseProof && itemMaster.purchaseProof.length > 0">
              <div class="md-layout-itemMaster md-size-30">
                <a :href="itemMaster.purchaseProof" target="_blank" v-on:click.stop="">
                  <span>Photo{{getFileExtension(itemMaster.purchaseProof)}}</span>
                </a>
              </div>
              <div class="md-layout-itemMaster md-size-30 serial-help-link">
                <a v-on:click.stop="removePurchaseProof(itemMaster)">{{$t('remove')}}</a>
              </div>
            </div>
          </md-table-cell>

          <!-- v-if="type=='estore', warranty days left | Out of Warranty -->
          <md-table-cell v-if="type=='estore'">
            <span v-if="itemMaster.warrantyDaysRemain>0">{{$t('warranty-days-left', {warrantyDaysRemain: itemMaster.warrantyDaysRemain})}}</span>
            <span v-if="itemMaster.warrantyDaysRemain<=0">{{$t('out-warranty')}}</span>
          </md-table-cell>

          <!-- v-if=="type=='retail'" (POP Date) -->
          <md-table-cell v-if="type=='retail'" style="position:relative;z-index:1;">
            <div v-on:click.stop="" style="width:100px;">
              <vue-date-picker v-model="itemMaster.purchaseDate" format="DD MMM YYYY" :placeholder="$t('select-date')" :no-calendar-icon="true" :fullscreen-mobile="true" min-date="2008-01-01" :max-date="today" @onChange="updatePurchaseDate(itemMaster)" />
            </div>
          </md-table-cell>
        </md-table-row>

        <!-- table row (child),  v-if="itemMaster.childOfMaster != 0 -->
        <md-table-row v-if="store == 'jp' && compareDate(itemMaster.warrantyExpiryDate, new Date()) != 'Expired'">
          <md-table-cell :colspan="(type=='estore'?4:5)">
            <div v-for="itemChild in products" v-bind:key="itemChild.id">

              <!-- JP Extended Warranty Message (Creative In Warranty) -->
              <div v-if="type=='estore' && store == 'jp' && (itemMaster.warrantyDaysRemain > 0 ) && extendedWarrantyListJP.includes(itemChild.sku) && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild)" class="jp-extended-msg">
                <span v-html="$t('creative-in-warranty')"></span>
                <br />
                ({{itemMaster.warrantyDaysRemain}})
                <div style="margin-top: 20px; color: blue">(This portion of text will appear when product is IN-CREATIVE-WARRANTY)</div>
              </div>

              <!-- JP Extended Warranty Message (Creative Out-Warranty) -->
              <div v-if="type=='estore' && store == 'jp' && (itemMaster.warrantyDaysRemain <= 0 ) && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild) && extendedWarrantyListJP.includes(itemChild.sku)" class="jp-extended-msg">
                <span v-html="$t('extended-warranty')"></span>
                <br />
                ({{itemMaster.warrantyDaysRemain}})
                <div style="margin-top: 20px; color: blue">(This portion of text will appear when product is OUT-OF-CREATIVE-WARRANTY)</div>
              </div>



              <!-- Listing Child Related Product -->
              <md-table v-if="(itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild) && !extendedWarrantyListJP.includes(itemChild.sku)">
                <!--v-if="type=='estore'", table header cell  -->
                <md-table-row v-if="type=='estore' && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild)">
                  <md-table-head class="tb-product-col">
                    {{ $t('select-your-products') }}
                  </md-table-head>
                  <md-table-head>{{$t('serial-number')}}</md-table-head>
                  <md-table-head v-if="!(store == 'jp')">{{$t('returns-eligibility')}}</md-table-head>
                  <md-table-head style="width:150px;">{{$t('warranty')}}</md-table-head>
                </md-table-row>

                <!--v-if="type=='retail'", table header cell  -->
                <md-table-row v-if="type=='retail' && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild)">
                  <md-table-head class="tb-product-col">{{$t('select-your-products')}}</md-table-head>
                  <md-table-head>{{$t('serial-number')}}</md-table-head>
                  <md-table-head v-if="type=='retail'">{{$t('order-id')}}</md-table-head>
                  <md-table-head>{{$t('proof-purchase')}}</md-table-head>
                  <md-table-head style="width:150px;">{{$t('purchase-date')}}</md-table-head>
                </md-table-row>

                <!-- prod image + checkbox -->
                <md-table-cell v-if="itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild">
                  <div class="md-layout md-alignment-center-center" v-on:click="select(itemChild)" :class="itemChild.submitted?'':'pointer'">
                    <span class="tb-product-exists" v-if="itemChild.submitted">{{$t('rma-exists')}}</span>
                    <!-- <span class="tb-product-exists" style="background-color:red" v-if="itemChild.childOfMaster != 0 || itemChild.childOfMaster != null">{{(itemChild.childOfMaster == 0) ? "Master" : "Child" }} </span> -->
                    <div class="md-layout-item md-size-10">
                      <md-checkbox v-model="itemChild.selected" :disabled="itemChild.submitted" class="product-checkbox" v-on:change="select(itemChild, 'change')" v-on:click.stop=""></md-checkbox>
                    </div>
                    <div class="md-layout md-size-40" style="align-items:center">
                      <div class="row-prod-item" style="width:100%; height:80px;background-size:contain;background-repeat:no-repeat" v-bind:style="{ backgroundImage: 'url(' + itemChild.image + ')' }">
                        <img class="tb-product-image" :src="itemChild.image" srcset="https://img.creative.com/images/dot-clear.gif" />
                      </div>
                    </div>
                    <div class="md-layout">
                      <div class="tb-product-desc">
                        <h4>{{itemChild.name}} ({{itemChild.sku}})</h4>
                        <div class="md-layout-item md-size-100 serial-help-link" style="padding-top:0" v-if="type=='retail'"><a v-on:click.stop="removeProduct(itemChild)">{{$t('remove')}}</a></div>
                      </div>
                    </div>
                  </div>
                </md-table-cell>

                <!-- serialNumber -->
                <md-table-cell v-if="itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild">
                  <div class="md-layout" v-if="!itemChild.serialNumberFinish && !itemChild.serialNumberLocked && !itemChild.submitted">
                    <div class="md-layout-itemChild md-size-100">
                      <input type="text" :class="'serial-num-input'+(type=='estore'?' serial-num-input-estore':'')" v-model="itemChild.serialNumber" v:value="itemChild.serialNumber" :placeholder="$t('enter-serial')" maxlength="19" v-on:click.stop="" v-on:keyup.enter="serialNumSubmit(itemChild)" v-on:blur="serialNumSubmit(itemChild)" />
                    </div>
                    <br />
                    <div class="md-error" v-if="itemChild.serialNumInvalid || itemChild.serialNumNotMatch" style="padding-top:8px;">{{$t('enter-serial-number')}} <span v-if="false">- {{itemChild.extraMsg}}</span></div>
                    <div class="md-error" v-if="itemChild.serialNumCreated" style="padding-top:8px;">{{$t('serial-num-submitted')}} <span v-if="false">- {{itemChild.extraMsg}}</span></div>
                    <div class="md-layout-itemChild md-size-100 serial-help-link"><a v-on:click.stop="serialNumHelp">{{$t('how-find-serial-num')}}</a></div>
                  </div>
                  <div class="md-layout" v-if="itemChild.serialNumberFinish || itemChild.serialNumberLocked">
                    <div class="md-layout-itemChild md-size-100">
                      {{itemChild.serialNumber}}
                    </div>
                    <div class="md-layout-itemChild md-size-100 serial-help-link" v-if="!itemChild.serialNumberLocked && !itemChild.submitted"><a v-on:click.stop="itemChild.serialNumberFinish=false">{{$t('edit')}}</a></div>
                  </div>
                </md-table-cell>

                <!--v-if="type=='retail'"-->
                <md-table-cell v-if="type=='retail' && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild)">
                  <div class="md-layout" v-if="!itemMaster.invoiceNumberFinish && !itemMaster.submitted">
                    <div class="md-layout-item md-size-100">
                      <input type="text" class="invoice-num-input" v-model="itemChild.invoiceNumber" maxlength="20" :placeholder="$t('order-number')" v-on:click.stop="" v-on:keyup.enter="invoiceSubmit(itemChild)" v-on:blur="invoiceSubmit(itemChild)" />
                    </div>
                    <div class="md-layout-item md-size-100 serial-help-link">
                      <span>{{$t('for-amazon-order')}}</span>
                    </div>
                  </div>
                  <div class="md-layout" v-if="itemChild.invoiceNumberFinish">
                    <div class="md-layout-item md-size-100">
                      {{itemChild.invoiceNumber}}
                    </div>
                    <div class="md-layout-itemChild md-size-100 serial-help-link" v-if="!itemChild.submitted"><a v-on:click.stop="itemChild.invoiceNumberFinish=false">{{$t('edit')}}</a></div>
                  </div>
                </md-table-cell>

                <!-- return eligibity, yes | no -->
                <md-table-cell v-if="itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild && type=='estore' &&  store != 'jp'">
                  <span v-if="itemChild.returnsEligibility">{{$t('yes')}}</span>
                  <span v-if="!itemChild.returnsEligibility">{{$t('no')}}</span>
                </md-table-cell>

                <!-- v-if=="type=='retail'" (POP Upload) -->
                <md-table-cell v-if="itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild && type=='retail'">
                  <div style="position:relative; overflow:hidden;" v-on:click.stop="" v-if="!itemChild.purchaseProof || itemChild.purchaseProof.length == 0">
                    <input type="file" v-on:change="upload($event, itemChild)" style="position:absolute; z-index: 10; top:0; left: 0; font-size:100px;opacity:0;" />
                    <md-button class="md-accent md-raised upload-button">{{$t('choose-file')}}</md-button>
                  </div>
                  <div v-if="itemChild.purchaseProof && itemChild.purchaseProof.length > 0">
                    <div class="md-layout-item md-size-30">
                      <a :href="itemChild.purchaseProof" target="_blank" v-on:click.stop="">
                        <span>Photo{{getFileExtension(itemChild.purchaseProof)}}</span>
                      </a>
                    </div>
                    <div class="md-layout-item md-size-30 serial-help-link">
                      <a v-on:click.stop="removePurchaseProof(itemChild)">{{$t('remove')}}</a>
                    </div>
                  </div>
                </md-table-cell>

                <!-- v-if="type=='estore', warranty days left | Out of Warranty -->
                <md-table-cell v-if="itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild && type=='estore'">
                  <span v-if="itemChild.warrantyDaysRemain>0">{{$t('warranty-days-left', {warrantyDaysRemain: itemChild.warrantyDaysRemain})}}</span>
                  <span v-if="itemChild.warrantyDaysRemain<=0">{{$t('out-warranty')}}</span>
                </md-table-cell>

                <!-- v-if=="type=='retail'" (POP Date) -->
                <md-table-cell v-if="itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild && type=='retail'" style="position:relative;z-index:1;">
                  <div v-on:click.stop="" style="width:100px;">
                    <vue-date-picker v-model="itemChild.purchaseDate" format="DD MMM YYYY" :placeholder="$t('select-date')" :no-calendar-icon="true" :fullscreen-mobile="true" min-date="2008-01-01" :max-date="today" @onChange="updatePurchaseDate(itemChild)" />
                  </div>
                </md-table-cell>

              </md-table>
            </div>
          </md-table-cell>
        </md-table-row>

      </md-table>

    </div>

    <!-- -----------   Mobile View  -----------  -->
    <div class="mobile-view md-size-100 md-small-size-100 md-small-show md-medium-hide md-large-hide md-xlarge-hide">
      <div class="md-layout">
        <div v-for="itemMaster in products" v-bind:key="itemMaster.id" v-on:click="select(itemMaster)" :class="'md-layout-item md-size-100'+itemMaster.submitted?'':'pointer'" style="border-bottom:1px solid #fff;margin-bottom:10px;padding-bottom:10px;position: relative;">

          <div class="md-layout" v-if="itemMaster.childOfMaster === null || itemMaster.childOfMaster === 0">
            <!-- (Left) Product Name + image -->
            <div class="md-layout-item md-size-40">
              <span class="tb-product-exists" v-if="itemMaster.submitted">{{$t('rma-exists')}}</span>
              <!-- Image -->
              <div class="md-layout md-alignment-center-center">
                <div class="md-layout-item md-size-20">
                  <md-checkbox v-model="itemMaster.selected" class="product-checkbox" v-on:change="select(itemMaster, 'change')" v-on:click.stop=""></md-checkbox>
                </div>
                <div class="md-layout-item md-size-80 md-centered" style="align-items:center">
                  <img class="tb-product-image" :src="itemMaster.image" />
                </div>
                <div class="md-layout-item tb-product-desc md-size-100 md-centered">
                  <h4>{{itemMaster.name}}</h4>
                </div>
              </div>
            </div>

            <!-- (Right) Serial Number +  OrderNumber + Return Eligibility + Warranty Status -->
            <div class="md-layout-item md-size-60">
              <div class="md-layout md-alignment-center-left">
                <div class="md-layout-item md-size-100" style="position:relative;z-index:1;">
                  <!-- Serial number -->
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div v-if="!itemMaster.serialNumberLocked && !itemMaster.submitted"><strong>{{$t('serial-number')}}</strong>:</div>
                      <div class="md-layout" v-if="!itemMaster.serialNumberFinish  && !itemMaster.serialNumberLocked && !itemMaster.submitted">
                        <div class="md-layout-item md-size-100">
                          <input type="text" class="serial-num-input" v-model="itemMaster.serialNumber" :placeholder="$t('enter-serial')"  maxlength="19" v-on:click.stop="" v-on:keyup.enter="serialNumSubmit(itemMaster)" v-on:blur="serialNumSubmit(itemMaster)" />
                        </div>
                        <div class="md-error" v-if="itemMaster.serialNumCreated" style="padding-top:8px;">{{$t('enter-serial-number')}} </div>
                        <div class="md-layout-item md-size-100 serial-help-link"><a v-on:click.stop="serialNumHelp">{{$t('how-find-serial-num')}}</a></div>
                      </div>
                      <div class="md-layout" v-if="itemMaster.serialNumberFinish || itemMaster.serialNumberLocked">
                        <div class="md-layout-item md-size-100">
                          {{itemMaster.serialNumber}}
                        </div>
                        <div class="md-layout-item md-size-100 serial-help-link"><a v-on:click.stop="itemMaster.serialNumberFinish=false">{{$t('edit')}}</a></div>
                      </div>
                    </div>
                  </div>
                  <!-- Invoice number -->
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div><strong>{{$t('order-id')}}</strong>:</div>
                      <div class="md-layout-item md-size-100" v-if="!itemMaster.invoiceNumberFinish">
                        <input type="text" class="invoice-num-input" v-model="itemMaster.invoiceNumber" maxlength="20" :placeholder="$t('order-number')" v-on:click.stop="" v-on:keyup.enter="invoiceSubmit(itemMaster)" v-on:blur="invoiceSubmit(itemMaster)" />
                      </div>
                      <div class="md-layout-item md-size-100" v-if="itemMaster.invoiceNumberFinish">
                        {{itemMaster.invoiceNumber}}<br />
                        <div class="md-layout-item md-size-100 serial-help-link"><a v-on:click.stop="itemMaster.invoiceNumberFinish=false">{{$t('edit')}}</a></div>
                      </div>
                    </div>
                  </div>
                  <!-- Returns -->
                  <div class="md-layout" v-if="type=='estore'">
                    <div class="md-layout-item" style="padding-top: 10px;">
                      <strong>{{$t('returns-eligibility')}}</strong>:
                      <span v-if="itemMaster.returnsEligibility">{{$t('yes')}}</span>
                      <span v-if="!itemMaster.returnsEligibility">{{$t('no')}}</span>
                    </div>
                  </div>
                  <!-- Warranty -->
                  <div class="md-layout" v-if="type=='estore'">
                    <div class="md-layout-item">
                      <strong>{{$t('warranty')}}</strong>:
                      <span v-if="itemMaster.warrantyDaysRemain>0">{{$t('warranty-days-left', {warrantyDaysRemain: itemMaster.warrantyDaysRemain})}}</span>
                      <span v-if="itemMaster.warrantyDaysRemain<=0">{{$t('out-warranty')}}</span>
                    </div>
                  </div>
                  <!-- Proof of Purchase -->
                  <div class="md-layout" v-if="type=='retail'">
                    <div class="md-layout-item" style="padding-top: 10px;">
                      <div style="display:block;"><strong>{{$t('proof-purchase')}}</strong>:</div>
                      <div style="position:relative; overflow:hidden;" v-on:click.stop="" v-if="!itemMaster.purchaseProof || itemMaster.purchaseProof.length == 0">
                        <input type="file" v-on:change="upload($event, itemMaster)" style="position:absolute; z-index: 10; top:0; left: 0; font-size:100px;opacity:0;" />
                        <md-button class="md-accent md-raised upload-button">{{$t('choose-file')}}</md-button>
                      </div>
                      <div v-if="itemMaster.purchaseProof && itemMaster.purchaseProof.length > 0">
                        <div class="md-layout-item md-size-100">
                          <a :href="itemMaster.purchaseProof" target="_blank" v-on:click.stop="">
                            <span>Photo{{getFileExtension(itemMaster.purchaseProof)}}</span>
                            <br /><span style="font-size:0.8em">({{$t('file-formats-allowed')}})</span>
                          </a>
                        </div>
                        <div class="md-layout-item md-size-100 serial-help-link">
                          <a v-on:click.stop="removePurchaseProof(item)">{{$t('remove')}}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Purchase Date -->
                  <div class="md-layout" v-if="type=='retail'">
                    <div class="md-layout-item">
                      <div>
                        <strong>{{$t('purchase-date')}}</strong>:
                      </div>
                      <div v-on:click.stop="" style="width:100px;">
                        <vue-date-picker v-model="itemMaster.purchaseDate" format="DD MMM YYYY" :placeholder="$t('select-date')" :no-calendar-icon="true" :fullscreen-mobile="true" min-date="2008-01-01" :max-date="today" @onChange="updatePurchaseDate(itemMaster)" />
                      </div>
                      <span class="remove-button">
                        <md-button class="md-icon-button icon-button-bin" v-on:click.stop="removeProduct(itemMaster)">
                          <md-icon><md-icon :md-src="`${imageServer}/new-rma/icon/bin.svg`"></md-icon></md-icon>
                        </md-button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--    Child Product listing  -->
          <div class="md-layout child-listing" v-for="itemChild in products" v-bind:key="itemChild.id">
            <div class="md-layout" v-if="(itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild) && !extendedWarrantyListJP.includes(itemChild.sku)" style="margin:20px 0 0 20px;padding:10px;border: 1px solid #dddddd">
              <!-- (Left) Product Name + image -->
              <div class="md-layout-item md-size-40">
                <span class="tb-product-exists" v-if="itemChild.submitted">{{$t('rma-exists')}}</span>
                <!-- Image -->
                <div class="md-layout md-alignment-center-center">
                  <div class="md-layout-item md-size-20">
                    <md-checkbox v-model="itemChild.selected" class="product-checkbox" v-on:change="select(itemChild, 'change')" v-on:click.stop=""></md-checkbox>
                  </div>
                  <div class="md-layout-item md-size-80 md-centered" style="align-items:center">
                    <img class="tb-product-image" :src="itemChild.image" />
                  </div>
                  <div class="md-layout-item tb-product-desc md-size-100 md-centered">
                    <h4>{{itemChild.name}}</h4>
                  </div>
                </div>
              </div>

              <!-- (Right) Serial Number +  OrderNumber + Return Eligibility + Warranty Status -->
              <div class="md-layout-item md-size-60">
                <div class="md-layout md-alignment-center-left">
                  <div class="md-layout-item md-size-100" style="position:relative;z-index:1;">
                    <!-- Serial number -->
                    <div class="md-layout">
                      <div class="md-layout-item">
                        <div v-if="!itemChild.serialNumberLocked && !itemChild.submitted"><strong>{{$t('serial-number')}}</strong>:</div>
                        <div class="md-layout" v-if="!itemChild.serialNumberFinish  && !itemChild.serialNumberLocked && !itemChild.submitted">
                          <div class="md-layout-item md-size-100">
                            <input type="text" class="serial-num-input" v-model="itemChild.serialNumber" placeholder="Enter Serial Number" maxlength="19" v-on:click.stop="" v-on:keyup.enter="serialNumSubmit(itemChild)" v-on:blur="serialNumSubmit(itemChild)" />
                          </div>
                          <div class="md-error" v-if="itemChild.serialNumCreated" style="padding-top:8px;">{{$t('enter-serial-number')}} </div>
                          <div class="md-layout-item md-size-100 serial-help-link"><a v-on:click.stop="serialNumHelp">{{$t('how-find-serial-num')}}</a></div>
                        </div>
                        <div class="md-layout" v-if="itemChild.serialNumberFinish || itemChild.serialNumberLocked">
                          <div class="md-layout-item md-size-100">
                            {{itemChild.serialNumber}}
                          </div>
                          <div class="md-layout-item md-size-100 serial-help-link"><a v-on:click.stop="itemChild.serialNumberFinish=false">{{$t('edit')}}</a></div>
                        </div>
                      </div>
                    </div>
                    <!-- Invoice number -->
                    <div class="md-layout">
                      <div class="md-layout-item">
                        <div><strong>{{$t('order-id')}}</strong>:</div>
                        <div class="md-layout-item md-size-100" v-if="!itemChild.invoiceNumberFinish">
                          <input type="text" class="invoice-num-input" v-model="itemChild.invoiceNumber" maxlength="20" placeholder="Enter Order Id" v-on:click.stop="" v-on:keyup.enter="invoiceSubmit(itemChild)" v-on:blur="invoiceSubmit(itemChild)" />
                        </div>
                        <div class="md-layout-item md-size-100" v-if="itemChild.invoiceNumberFinish">
                          {{itemChild.invoiceNumber}}<br />
                          <div class="md-layout-item md-size-100 serial-help-link"><a v-on:click.stop="itemChild.invoiceNumberFinish=false">{{$t('edit')}}</a></div>
                        </div>
                      </div>
                    </div>
                    <!-- Returns -->
                    <div class="md-layout" v-if="type=='estore'">
                      <div class="md-layout-item" style="padding-top: 10px;">
                        <strong>{{$t('returns-eligibility')}}</strong>:
                        <span v-if="itemChild.returnsEligibility">{{$t('yes')}}</span>
                        <span v-if="!itemChild.returnsEligibility">{{$t('no')}}</span>
                      </div>
                    </div>
                    <!-- Warranty -->
                    <div class="md-layout" v-if="type=='estore'">
                      <div class="md-layout-item">
                        <strong>{{$t('warranty')}}</strong>:
                        <span v-if="itemChild.warrantyDaysRemain>0">{{$t('warranty-days-left', {warrantyDaysRemain: itemChild.warrantyDaysRemain})}}</span>
                        <span v-if="itemChild.warrantyDaysRemain<=0">{{$t('out-warranty')}}</span>
                      </div>
                    </div>
                    <!-- Proof of Purchase -->
                    <div class="md-layout" v-if="type=='retail'">
                      <div class="md-layout-item" style="padding-top: 10px;">
                        <div style="display:block;"><strong>{{$t('proof-purchase')}}</strong>:</div>
                        <div style="position:relative; overflow:hidden;" v-on:click.stop="" v-if="!itemChild.purchaseProof || itemChild.purchaseProof.length == 0">
                          <input type="file" v-on:change="upload($event, itemChild)" style="position:absolute; z-index: 10; top:0; left: 0; font-size:100px;opacity:0;" />
                          <md-button class="md-accent md-raised upload-button">{{$t('choose-file')}}</md-button>
                        </div>
                        <div v-if="itemChild.purchaseProof && itemChild.purchaseProof.length > 0">
                          <div class="md-layout-item md-size-100">
                            <a :href="itemChild.purchaseProof" target="_blank" v-on:click.stop="">
                              <span>Photo{{getFileExtension(itemChild.purchaseProof)}}</span>
                              <br /><span style="font-size:0.8em">({{$t('file-formats-allowed')}})</span>
                            </a>
                          </div>
                          <div class="md-layout-item md-size-100 serial-help-link">
                            <a v-on:click.stop="removePurchaseProof(itemChild)">{{$t('remove')}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Purchase Date -->
                    <div class="md-layout" v-if="type=='retail'">
                      <div class="md-layout-item">
                        <div>
                          <strong>{{$t('purchase-date')}}</strong>:
                        </div>
                        <div v-on:click.stop="" style="width:100px;">
                          <vue-date-picker v-model="itemChild.purchaseDate" format="DD MMM YYYY" :placeholder="$t('select-date')" :no-calendar-icon="true" :fullscreen-mobile="true" min-date="2008-01-01" :max-date="today" @onChange="updatePurchaseDate(itemChild)" />
                        </div>
                        <span class="remove-button">
                          <md-button class="md-icon-button icon-button-bin" v-on:click.stop="removeProduct(itemChild)">
                            <md-icon><md-icon :md-src="`${imageServer}/new-rma/icon/bin.svg`"></md-icon></md-icon>
                          </md-button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <!-- JP Extended Warranty Message (Creative In Warranty) -->
                <div v-if="type=='estore' && store == 'jp' && itemChild.warrantyDaysRemain > 0 && extendedWarrantyListJP.includes(itemChild.sku) && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild)" :class="mobile-jp-extended-msg" style="border:1px solid red;padding:5px;color:red">
                  Product covered by extended warranty (To be translated to Japanese)
                  <br />
                  For part number: 9900000000337,9900000000338,9900000000339
                </div>

                <!-- JP Extended Warranty Message (Creative Out-Warranty) -->
                <div v-if="type=='estore' && store == 'jp' && itemChild.warrantyDaysRemain <= 0 && (itemChild.childOfMaster != 0 && itemChild.childOfMaster == itemMaster.masterOfChild) && extendedWarrantyListJP.includes(itemChild.sku)">
                  <div>
                    <div :colspan="(type=='estore'?4:5)" class="mobile-jp-extended-msg">
                      ご選択いただいたシリアル番号/ご注文番号の製品は、現在延長保証の適用期間となっております。
                      延長保証期間中の保証対応につきましては、弊社の延長保証の運営会社であるSOMPOワランティ株式会社での対応となりますので、
                      <a href="https://www.sompo-swt.com/join/repair.html" target="_blank" style="text-decoration:underline">こちらをご確認</a>
                      のうえお問合せ/お申込みをお願いいたします。
                      <br />
                      For part number: 9900000000337,9900000000338,9900000000339
                    </div>
                  </div>
                </div>
                </div>
            </div>


          </div>

        </div>
      </div>
    </div>


    <div v-if="this.type == 'retail'" style="text-align:right;font-size:0.8em;">{{$t('file-formats-allowed')}}</div>
    <md-snackbar :md-active.sync="showSerialNumMsg" :md-duration="8000">{{$t('serial-not-valid')}}</md-snackbar>
    <md-snackbar :md-active.sync="showUploadFormatMsg" :md-duration="8000">{{$t('file-formats-allowed')}}</md-snackbar>
    <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>
    <md-snackbar :md-active.sync="showRMAExistsMsg" :md-duration="8000">{{$t('rma-created')}}</md-snackbar>
    <md-snackbar :md-active.sync="showMaxLimitMsg" :md-duration="8000">{{$t('selected-maximum')}}</md-snackbar>
    <div class="loading-overlayer" v-if="loading" v-on:click.stop="">
      <div class="md-layout md-alignment-center-center" style="height:100%">
        <md-progress-spinner md-mode="indeterminate" :md-diameter="50"></md-progress-spinner>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import Auth from '../mixins/auth'
  import { VueDatePicker } from '@mathieustan/vue-datepicker';
  import { Date } from 'core-js';
  import { apiServer, imageServer } from '../config'
  export default {
    name: 'ProductTable',
    props: {
      products: Array,
      type: String,
      action: Number
    },
    data: () => ({
      loading: false,
      today: new Date(),
      showSerialNumMsg: false,
      showUploadFormatMsg: false,
      imageServer: imageServer,
      showErrorMsg: false,
      showRMAExistsMsg: false,
      showMaxLimitMsg: false,
      extraMsg: "",
      test: ['1', '70SA016000000'],
      extendedWarrantyListJP: ['9900000000337', '9900000000338', '9900000000339']
    }),
    components: {
      VueDatePicker
    },
    computed: {
      ...mapState({
        store: 'store',
        step: 'step',
        productSelected: 'prodList',
        orderSelectedCount: 'orderSelectedCount',
        retailSelectedCount: 'retailSelectedCount'
      })
    },
    methods: {
      ...mapMutations({
        changeStep: types.CHANGE_STEP,
        selectProduct: types.SELECT_PRODUCT,
        showLoading: types.SHOW_LOADING,
        hideLoading: types.HIDE_LOADING
      }),
      compareDate(purchaseDate, dateNow) {
        const datePurchase = new Date(purchaseDate)
        let dateExpired = new Date(purchaseDate)
        dateExpired = new Date(dateExpired.setFullYear(datePurchase.getFullYear() + 5))
        let result = 'Within Warranty'

        if (dateNow > dateExpired  )  result = 'Expired'
        if (dateNow >= datePurchase  && dateNow <= dateExpired )  result = 'Within Extended Warranty'
        return result
      },
      select(item, method) {
        if (item.submitted) {
          this.showRMAExistsMsg = true
          return
        }
        const count = this.type == 'estore' ? this.orderSelectedCount : this.retailSelectedCount;
        if (method != 'change')
          item.selected = !item.selected
        if (item.selected && count >= 5) {
          item.selected = false
          this.showMaxLimitMsg = true
          return
        }
        this.showLoading()
        this.loading = true
        if (!item.selected) item.actionSelected = 0
        else item.actionSelected = parseInt(this.action)
        item.store = this.store
        this.$http.post(`${apiServer}/api/your-products/update-product`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false
          if (data && data.products) this.selectProduct(data.products)
          this.changeStep(2)
          this.$emit('refresh')
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      serialNumSubmit(item) {
        this.showLoading()
        this.loading = true
        this.$http.post(`${apiServer}/api/your-products/update-serial-number`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false

          if (data && data.products && data.status == 'success') {
            window.console.log("success")
            this.selectProduct(data.products)
            item.serialNumberFinish = true
            this.$emit('refresh')
          }
          else if (data && data.status == 'created') {
            item.extraMsg = "(Duplicate S/N)"
            item.serialNumCreated = true
          }
          else if (data && data.status == "invalid")
          {
            item.extraMsg = "(Invalid S/N)"
            item.serialNumInvalid = true
          }
          else if (data && data.status == "notmatch")
          {
            item.extraMsg = "(S/N not match)"
            item.serialNumNotMatch = true
          }
          else {
            window.console.log(data.status + " - dunno")
            this.showSerialNumMsg = true
          }
        }).catch(() => {
          window.console.log("catch err")
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },

      invoiceSubmit(item) {
        this.showLoading()
        this.loading = true

        this.$http.post(`${apiServer}/api/your-products/update-invoice-number`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false

          if (data  && data.status == 'success') {
            this.selectProduct(data.products)
            item.invoiceNumberFinish = !(item.invoiceNumber == "");

            this.$emit('refresh')
          }
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })

      },

      removeProduct(item) {
        this.showLoading()
        this.loading = true
        this.$http.put(`${apiServer}/api/your-products/remove`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false
          if (data && data.products) {
            this.selectProduct(data.products)
            this.$emit('refresh')
          }
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      serialNumHelp() {
        if (this.store.toLowerCase() == 'jp')
          window.open("https://jp.creative.com/support/kb/welcome.asp?catid=1007&pid=22563&sid=6843", "_blank");
        else
          window.open("https://support.creative.com/kb/ShowArticle.aspx?sid=6843", "_blank");

        return
      },
      upload(e, item) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          this.showUploadFormatMsg = true
          return
        }
        const name = files[0].name.toLowerCase()
        const ext = name.substr(name.lastIndexOf('.') + 1);
        //window.console.log(ext)
        if (['jpg', 'gif', 'png', 'pdf', 'webp', 'zip'].indexOf(ext) == -1) {
          this.showUploadFormatMsg = true
          return
        }
        this.showLoading()
        this.loading = true
        //  //window.console.log(files[0])
        let formData = new FormData()
        formData.append('file', files[0])
        formData.append('sourceId', item.sourceId)
        this.$http.post(`${apiServer}/api/your-products/upload-file`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${Auth.getToken()}`
            }
          }).then(({ data }) => {
            this.hideLoading()
            this.loading = false
            if (data && data.products) {
              this.selectProduct(data.products)
              this.$emit('refresh')
            }
            else {
              this.showErrorMsg = true
            }
          }).catch(() => {
            this.hideLoading()
            this.loading = false
            this.showErrorMsg = true
          })
      },
      removePurchaseProof(item) {
        this.showLoading()
        this.loading = true
        this.$http.post(`${apiServer}/api/your-products/remove-file`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false
          if (data && data.products) {
            this.selectProduct(data.products)
            this.$emit('refresh')
          }
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      updatePurchaseDate(item) {
        this.showLoading()
        this.loading = true
        this.$http.post(`${apiServer}/api/your-products/update-purchase-date`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false
          if (data && data.products) {
            this.selectProduct(data.products)
            this.$emit('refresh')
          }
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      getFileExtension(url) {
        const ext = url.split(/#|\?/)[0].split('.').pop().trim()
        if (ext && ext.length > 0)
          return '.' + ext
        else
          return ''
      }
    }
  }
</script>

<style lang="scss">

  .md-table-cell.jp-extended-msg {
    border-top: none;
  }

  .tb-product-col {
    width: 320px
  }

  .tb-product-desc {
    padding-left: 15px;
    h4
  {
    padding-bottom: 0;
    margin-bottom: 8px;
  }

  p {
    padding: 0;
    margin: 0;
  }

  }

  .tb-product-exists {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 10px;
    background-color: #c71919;
    color: #fff;
    padding: 1px 10px;
  }

  .product-checkbox {
    margin: 4px 0;
  }

  .serial-num-input {
    height: 36px;
    line-height: 36px;
    border: solid 1px #827f7f;
    background-color: white;
    border-radius: 4px;
    width: 160px;
    padding: 0 5px;
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button  {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }

  .serial-num-input-estore {
    width: 240px;
  }

  .invoice-num-input {
    height: 36px;
    width: 150px;
    line-height: 36px;
    border: solid 1px #827f7f;
    background-color: white;
    border-radius: 4px;
    padding: 0 10px;
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button  {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }

  .pointer {
    cursor: pointer;
  }

  .serial-help-link {
    padding-top: 5px;
    font-size: 0.9em;
    width:100%;
    a,span  {
      color: #7c7979 !important;
    }
  }


  @media only screen and (max-width: 1080px) {
    .serial-help-link {
      font-size: 0.8em;
    }
  }
    .remove-button {
      position: absolute;
      top: 10px;
      right: 0;
      z-index: 10;
    }

    .upload-button {
      border-radius: 0;
      height: 28px !important;
      .md-ripple {
        padding: 0 5px !important;
        .md-button-content {
          font-size: 12px !important;
        }
      }
  }

  .icon-button-bin {
    width: 22px  !important;
    height: 22px  !important;
    min-width: 22px  !important;
    .md-ripple {
      padding: 0 !important;
      svg  {
        width: 16px;
        height: 16px;
      }
    }
  }

  .loading-overlayer {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffff4f;
  }

  .serial-help-link a {
    cursor: pointer;
  }

  .row-prod-item {
    width: 100%;
    height: 80px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .mobile-view .md-layout-item > img {
    max-width: 70%;
  }

  .mobile-view .md-layout-item .tb-product-desc h4
  {
    padding-bottom: 0;
    margin-bottom: 8px;
    margin-top: 10px;
  }

  .mobile-view .md-layout-item .tb-product-desc
  {
    padding-left: 50px;
    padding-right: 20px;
  }

  .jp-extended-msg, .mobile-jp-extended-msg {
    border: 1px solid red;
    padding: 10px;

    color: red !important;
  }

  .mobile-jp-extended-msg {
    margin-top: 20px;
  }
</style>